export default {
    0: {
        north: [
            {
                roomNumber: 'HK',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 8,
                clickable: false,
            },
            {
                roomNumber: '',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: 'Lépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: 'Zuhanyzó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: 'Iroda',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: 'WC - Vizesblokk',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 12,
                clickable: false,
            },
            {
                roomNumber: 'Lépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: 'Könyvtár',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 8,
                clickable: false,
            },
            {
                roomNumber: 'Raktár',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: 'Főlépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 16,
                clickable: false,
            },
            {
                roomNumber: 'Porta',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: 'Kármán Klub',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 12,
                clickable: false,
            },
        ],
        corridor: [
            {
                roomNumber: 'HK',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 8,
                clickable: false,
            },
            {
                roomNumber: 'Kapubejáró',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: 'Folyosó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 40,
                clickable: false,
            },
            {
                roomNumber: 'Aula',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 20,
                clickable: false,
            },
            {
                roomNumber: 'Kármán Klub',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 12,
                clickable: false,
            },
        ],
        south: [
            {
                roomNumber: 'HK',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 8,
                clickable: false,
            },
            {
                roomNumber: '',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: 'Iroda',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: 'Iroda',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: '005',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '007',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'Hallgatói Nagy Terem',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 12,
                clickable: false,
            },
            {
                roomNumber: 'TTK HK',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: 'TTK HK',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: 'Iroda',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
                clickable: false,
            },
            {
                roomNumber: 'Iroda',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
                clickable: false,
            },
            {
                roomNumber: 'Hallgatói Helyiség',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: 'Aula',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 16,
                clickable: false,
            },
            {
                roomNumber: 'Bejárat',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: 'Kármán Klub',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 12,
                clickable: false,
            },
        ],
    },
    1: {
        north: [
            {
                roomNumber: '102',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '104',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '106',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '108',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '110',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '112',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'Lépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: '116',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '118',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '120',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '122',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'WC - Zuhanyzó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 12,
                clickable: false,
            },
            {
                roomNumber: 'Lépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: '132',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '134',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'Társalgó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: 'Konyha',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 6,
                clickable: false,
            },
            {
                roomNumber: 'Főlépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 14,
                clickable: false,
            },
            {
                roomNumber: 'Raktár',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: '142',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '144',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '146',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '148',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '150',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '152',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
        ],
        corridor: [
            {
                roomNumber: 'Folyosó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 84,
                clickable: false,
            },
        ],
        south: [
            {
                roomNumber: '101',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '103',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '105',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '107',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '109',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '111',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '113',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '114',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '115',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '117',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '119',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '121',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '123',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '124',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '125',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '126',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '127',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '128',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '129',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '130',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '131',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '133',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '135',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '136',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '137',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '138',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'Galéria',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 16,
                clickable: false,
            },
            {
                roomNumber: '139',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '140',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '141',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '143',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '145',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '147',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '149',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '151',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
        ],
    },
    2: {
        north: [
            {
                roomNumber: '202',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '204',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '206',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '208',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '210',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '212',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'Lépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: '216',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '218',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '220',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '222',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'WC - Zuhanyzó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 12,
                clickable: false,
            },
            {
                roomNumber: 'Lépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: '232',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '234',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '236',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'Gondnoki',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
                clickable: false,
            },
            {
                roomNumber: 'Konyha',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 6,
                clickable: false,
            },
            {
                roomNumber: 'Főlépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 14,
                clickable: false,
            },
            {
                roomNumber: 'Nevelői',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
            },
            {
                roomNumber: '252',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '254',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '256',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '258',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '260',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '261',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
        ],
        corridor: [
            {
                roomNumber: 'Folyosó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 84,
                clickable: false,
            },
        ],
        south: [
            {
                roomNumber: '201',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '203',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '205',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '207',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '209',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '211',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '213',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '214',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '215',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '217',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '219',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '221',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '223',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '224',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '225',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '226',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '227',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '228',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '229',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '230',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '231',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '233',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '235',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '237',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '238',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '239',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '240',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '241',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '242',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '243',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '244',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '245',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '246',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '247',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '248',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '249',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '250',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '251',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '253',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '255',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '257',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '259',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
        ],
    },
    3: {
        north: [
            {
                roomNumber: '302',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '304',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '306',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '308',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '310',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '312',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'Lépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: '316',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '318',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '320',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '322',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'WC - Zuhanyzó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 12,
                clickable: false,
            },
            {
                roomNumber: 'Lépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: '332',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '334',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '336',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'Társalgó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
                clickable: false,
            },
            {
                roomNumber: 'Konyha',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 6,
                clickable: false,
            },
            {
                roomNumber: 'Főlépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 14,
                clickable: false,
            },
            {
                roomNumber: 'Nevelői',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
            },
            {
                roomNumber: '352',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '354',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '356',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '358',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '360',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '361',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
        ],
        corridor: [
            {
                roomNumber: 'Folyosó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 84,
                clickable: false,
            },
        ],
        south: [
            {
                roomNumber: '301',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '303',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '305',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '307',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '309',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '311',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '313',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '314',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '315',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '317',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '319',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '321',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '323',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '324',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '325',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '326',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '327',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '328',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '329',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '330',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '331',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '333',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '335',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '337',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '338',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '339',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '340',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '341',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '342',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '343',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '344',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '345',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '346',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '347',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '348',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '349',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '350',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '351',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '353',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '355',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '357',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '359',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
        ],
    },
    4: {
        north: [
            {
                roomNumber: '402',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '404',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '406',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '408',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '410',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '412',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'Lépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: '416',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '418',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '420',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '422',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'WC - Zuhanyzó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 12,
                clickable: false,
            },
            {
                roomNumber: 'Lépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: '432',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '434',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'Társalgó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: 'Konyha',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 6,
                clickable: false,
            },
            {
                roomNumber: 'Főlépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 14,
                clickable: false,
            },
            {
                roomNumber: 'Nevelői',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
            },
            {
                roomNumber: '450',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '452',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '454',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '456',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '458',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '460',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
        ],
        corridor: [
            {
                roomNumber: 'Folyosó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 84,
                clickable: false,
            },
        ],
        south: [
            {
                roomNumber: '401',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '403',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '405',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '407',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '409',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '411',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '413',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '414',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '415',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '417',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '419',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '421',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '423',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '424',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '425',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '426',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '427',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '428',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '429',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '430',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '431',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '433',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '435',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '436',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '437',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '438',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '439',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '440',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '441',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '442',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '443',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '444',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '445',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '446',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '447',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '448',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '449',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '451',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '453',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '455',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '457',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '459',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
        ],
    },
    5: {
        north: [
            {
                roomNumber: '502',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '504',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '506',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '508',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '510',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '512',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'Lépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: '516',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '518',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '520',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '522',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'WC - Zuhanyzó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 12,
                clickable: false,
            },
            {
                roomNumber: 'Lépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: '532',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '534',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '536',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'Társalgó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
                clickable: false,
            },
            {
                roomNumber: 'Konyha',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 6,
                clickable: false,
            },
            {
                roomNumber: 'Főlépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 14,
                clickable: false,
            },
            {
                roomNumber: 'Nevelői',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
            },
            {
                roomNumber: '552',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '554',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '556',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '558',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '560',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '561',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
        ],
        corridor: [
            {
                roomNumber: 'Folyosó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 84,
                clickable: false,
            },
        ],
        south: [
            {
                roomNumber: '501',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '503',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '505',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '507',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '509',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '511',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '513',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '514',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '515',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '517',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '519',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '521',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '523',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '524',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '525',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '526',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '527',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '528',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '529',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '530',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '531',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '533',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '535',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '537',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '538',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '539',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '540',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '541',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '542',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '543',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '544',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '545',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '546',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '547',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '548',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '549',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '550',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '551',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '553',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '555',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '557',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '559',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
        ],
    },
    6: {
        north: [
            {
                roomNumber: '602',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '604',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '606',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '608',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '610',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '612',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'Lépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: '616',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '618',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '620',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '622',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'WC - Zuhanyzó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 12,
                clickable: false,
            },
            {
                roomNumber: 'Lépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: '632',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '634',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '636',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'Gondnoki',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
                clickable: false,
            },
            {
                roomNumber: 'Konyha',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 6,
                clickable: false,
            },
            {
                roomNumber: 'Főlépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 14,
                clickable: false,
            },
            {
                roomNumber: 'Nevelői',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
            },
            {
                roomNumber: '652',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '654',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '656',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '658',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '660',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '661',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
        ],
        corridor: [
            {
                roomNumber: 'Folyosó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 84,
                clickable: false,
            },
        ],
        south: [
            {
                roomNumber: '601',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '603',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '605',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '607',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '609',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '611',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '613',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '614',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '615',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '617',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '619',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '621',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '623',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '624',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '625',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '626',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '627',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '628',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '629',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '630',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '631',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '633',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '635',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '637',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '638',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '639',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '640',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '641',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '642',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '643',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '644',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '645',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '646',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '647',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '648',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '649',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '650',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '651',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '653',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '655',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '657',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '659',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
        ],
    },
    7: {
        north: [
            {
                roomNumber: '702',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '704',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '706',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '708',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '710',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '712',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'Lépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: '716',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '718',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '720',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '722',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'WC - Zuhanyzó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 12,
                clickable: false,
            },
            {
                roomNumber: 'Lépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: '732',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '734',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'Társalgó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: 'Konyha',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 6,
                clickable: false,
            },
            {
                roomNumber: 'Főlépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 14,
                clickable: false,
            },
            {
                roomNumber: 'Nevelői',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
            },
            {
                roomNumber: '750',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '752',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '754',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '756',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '758',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '760',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
        ],
        corridor: [
            {
                roomNumber: 'Folyosó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 84,
                clickable: false,
            },
        ],
        south: [
            {
                roomNumber: '701',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '703',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '705',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '707',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '709',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '711',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '713',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '714',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '715',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '717',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '719',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '721',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '723',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '724',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '725',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '726',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '727',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '728',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '729',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '730',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '731',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '733',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '735',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '736',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '737',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '738',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '739',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '740',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '741',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '742',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '743',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '744',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '745',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '746',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '747',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '748',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '749',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '751',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '753',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '755',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '757',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '759',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
        ],
    },
    8: {
        north: [
            {
                roomNumber: '802',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '804',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '806',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '808',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '810',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '812',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'Lépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: '816',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '818',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '820',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '822',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'WC - Zuhanyzó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 12,
                clickable: false,
            },
            {
                roomNumber: 'Lépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: '832',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '834',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '836',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'Műhely',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
                clickable: false,
            },
            {
                roomNumber: 'Konyha',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 6,
                clickable: false,
            },
            {
                roomNumber: 'Főlépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 14,
                clickable: false,
            },
            {
                roomNumber: 'Nevelői',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
            },
            {
                roomNumber: '852',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '854',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '856',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '858',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '860',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '861',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
        ],
        corridor: [
            {
                roomNumber: 'Folyosó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 84,
                clickable: false,
            },
        ],
        south: [
            {
                roomNumber: '801',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '803',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '805',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '807',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '809',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '811',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '813',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '814',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '815',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '817',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '819',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '821',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '823',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '824',
                description:
                    // 'Fauszt és Grant második szobája, illetve később Évi is lakott itt.',
                    '',
                width: 2,
            },
            {
                roomNumber: '825',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '826',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '827',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '828',
                description:
                    // 'Történelmi jelentőségű szoba: itt lakott először Fauszt és Grant a koliban.',
                    '',
                width: 2,
            },
            {
                roomNumber: '829',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '830',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '831',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '833',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '835',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '837',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '838',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '839',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '840',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '841',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '842',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '843',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '844',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '845',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '846',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '847',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '848',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '849',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '850',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '851',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '853',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '855',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '857',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '859',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
        ],
    },
    9: {
        north: [
            {
                roomNumber: 'Tető',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 12,
                clickable: false,
            },
            {
                roomNumber: 'Lépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: '901',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '902',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '903',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '904',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'Zuhanyzó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: 'Hallgatói Helyiség',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: 'WC',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: 'Lépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
            {
                roomNumber: '905',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '906',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '907',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'Társalgó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
                clickable: false,
            },
            {
                roomNumber: 'Konyha',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 6,
                clickable: false,
            },
            {
                roomNumber: 'Főlépcső',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 14,
                clickable: false,
            },
            {
                roomNumber: 'Nevelői',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
            },
            {
                roomNumber: '908',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '909',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '910',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: '911',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 2,
            },
            {
                roomNumber: 'Teraszos Társalgó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
        ],
        corridor: [
            {
                roomNumber: 'Tető',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 12,
                clickable: false,
            },
            {
                roomNumber: 'Folyosó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 68,
                clickable: false,
            },
            {
                roomNumber: 'Teraszos Társalgó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 4,
                clickable: false,
            },
        ],
        south: [
            {
                roomNumber: 'Tető',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 68,
                clickable: false,
            },
            {
                roomNumber: 'Teraszos Társalgó',
                description:
                    // 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae, consectetur dolorum ducimus maximenatus omnis optio porro quos voluptatem.',
                    '',
                width: 16,
                clickable: false,
            },
        ],
    },
};
